import { render, staticRenderFns } from "./DocumentReadyDialog.vue?vue&type=template&id=89746dfa"
import script from "./DocumentReadyDialog.vue?vue&type=script&lang=ts"
export * from "./DocumentReadyDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports